import * as yup from "yup";

export default yup.object().shape({
    email: yup.string().email("Format d'email invalide").required("Le champ email est obligatoire"),
    password: yup.string().required("Le champ mot de passe est obligatoire")
})
